import React, { useMemo } from "react";
import { useQuery } from "@apollo/client";

const ID_KEY_RE = /(^id$|Id$|ID$)/;

/**
 * Recursively coerce any variables whose key name looks like "id" to numbers
 * when they are numeric strings (e.g., "1" -> 1). Leaves everything else intact.
 */
function coerceIdsDeep(input) {
  if (Array.isArray(input)) {
    return input.map(coerceIdsDeep);
  }
  if (input && typeof input === "object") {
    const out = {};
    for (const [k, v] of Object.entries(input)) {
      if (
        ID_KEY_RE.test(k) &&
        typeof v === "string" &&
        /^\s*-?\d+\s*$/.test(v) // allow optional minus/whitespace
      ) {
        const n = Number(v);
        out[k] = Number.isNaN(n) ? v : n;
      } else if (v && typeof v === "object") {
        out[k] = coerceIdsDeep(v);
      } else {
        out[k] = v;
      }
    }
    return out;
  }
  return input;
}

const WithGqlQuery = ({
  component: Component,
  query,
  variables = {},
  fetchPolicy = "cache-first",
  pageProps,
  ...rest
}) => {
  // Make sure variables sent to Apollo have numeric IDs
  const safeVariables = useMemo(() => coerceIdsDeep(variables), [variables]);

  console.log("WithGqlQuery: query variables:", safeVariables);
  const { data, loading, error } = useQuery(query, {
    variables: safeVariables,
  });

  return (
    <Component
      maxWidth="lg"
      data={data}
      loading={loading}
      error={error}
      pageProps={pageProps}
      {...rest}
    />
  );
};

export default WithGqlQuery;
